import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import ReportAndon from "../Reports/reportAndonAction";
import ReportOEE from "../Reports/reportOEE";
import ReportRefuses from "../Reports/reportRefuses";
import ReportStops from "../Reports/reportStops";
import ReportOrder from "../Reports/reportOrders";
import ReportOeeWorkShift from "../Reports/reportOeeWorkShift";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import "./prelude.css";
import BottomBar from "../../Components/bottomBar/bottomBar";
import { handleColor } from "../../services/Functions";
import { Redirect } from "react-router-dom";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";
class Sidebar extends React.Component {
  state = { data: [], render: false, redirect: false, click: false };

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { redirect } = this.state;
    const items = [
      { id: "lg1", label: "Histórico de Paradas", eventKey: "stops" },
      { id: "lg2", label: "Histórico de Refugos", eventKey: "refuses" },
      { id: "lg3", label: "Ordens", eventKey: "order" },
      { id: "lg4", label: "Apontamentos", eventKey: "oee" },
      { id: "lg5", label: "Andon", eventKey: "andon" },
      { id: "lg6", label: "OEE x Turno", eventKey: "oeeWorkShift" },
    ];

    if (redirect) return <Redirect to="/relatorios"></Redirect>;

    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1">
            <div
              className={this.props.isMobile ? "sidebar2-mobile" : "sidebar2"}
            >
              <Col className="sidebarColumn" mountOnEnter unmountOnExit>
                <ListGroup>
                  {items.map((item) =>
                    this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            this.props.handleClose();
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    )
                  )}
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
                width: "100%",
              
              }}
            >
              {!this.props.isMobile && (
                <Tab.Content>
                  <Tab.Pane
                    className="col5"
                    mountOnEnter
                    unmountOnExit
                    eventKey="stops"
                  >
                    {this.handleClick ? <ReportStops /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    className="col5"
                    mountOnEnter
                    unmountOnExit
                    eventKey="order"
                  >
                    {this.handleClick ? <ReportOrder /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    className="col5"
                    mountOnEnter
                    unmountOnExit
                    eventKey="refuses"
                  >
                    {this.handleClick ? <ReportRefuses /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    className="col5"
                    mountOnEnter
                    unmountOnExit
                    eventKey="oee"
                  >
                    {this.handleClick ? <ReportOEE /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    className="col5"
                    mountOnEnter
                    unmountOnExit
                    eventKey="andon"
                  >
                    {this.handleClick ? <ReportAndon /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    className="col5"
                    mountOnEnter
                    unmountOnExit
                    eventKey="oeeWorkShift"
                  >
                    {this.handleClick ? <ReportOeeWorkShift /> : null}
                  </Tab.Pane>
                </Tab.Content>
              )}
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

function prelude_reports() {
  const [activeTab, setActiveTab] = React.useState("stops");
  return (
    <>
      <div>
        <Top_bar title="Relatórios" />{" "}
      </div>
      <div className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </div>
      <footer>
        <BottomBar></BottomBar>
      </footer>
    </>
  );
}

export default prelude_reports;
